import { api } from "@/api/client";

export interface SubscriptionPlanDto {
  id: string;
  key: string;
  name: string;
  displayName: string | null;
  creditsPerPeriod: number;
  periodDays: number;
  priceRials: number;
  priceCents: number;
  deliveryDaysMin: number | null;
  deliveryDaysMax: number | null;
  features: unknown;
  isPopular: boolean;
  isActive: boolean;
}

export interface SpecificationPriceDto {
  id: string;
  key: string;
  category: string;
  label: string;
  labelFa: string | null;
  description: string | null;
  descriptionFa: string | null;
  priceRials: number;
  priceCents: number;
  sortOrder: number;
  isActive: boolean;
}

export interface StyleDto {
  id: string;
  key: string;
  product: string;
  name: string;
  nameFa: string | null;
  description: string | null;
  descriptionFa: string | null;
  promptHint: string | null;
  sortOrder: number;
  isActive: boolean;
}

export async function listPlans(): Promise<SubscriptionPlanDto[]> {
  return api<SubscriptionPlanDto[]>("/catalog/plans", { skipAuth: true });
}

export async function listSpecificationPrices(): Promise<
  SpecificationPriceDto[]
> {
  return api<SpecificationPriceDto[]>("/catalog/specification-prices", {
    skipAuth: true,
  });
}

export async function listStyles(): Promise<StyleDto[]> {
  return api<StyleDto[]>("/catalog/styles", { skipAuth: true });
}

export interface ProductOfferingPublicDto {
  productType: "toy" | "story" | "animation" | "game";
  name: string;
  nameEn: string | null;
  sortOrder: number;
}

export async function listProductOfferings(): Promise<
  ProductOfferingPublicDto[]
> {
  return api<ProductOfferingPublicDto[]>("/catalog/product-offerings", {
    skipAuth: true,
  });
}

export interface PublishedConversionServiceDto {
  slug: string;
  name: string;
  description: string | null;
  wizardBackgroundUrl: string | null;
  landingVideoUrl: string | null;
  landingHero: {
    sortOrder: number;
    chipIcon: string;
    fa: Record<string, string>;
    en: Record<string, string>;
  } | null;
}

export async function listPublishedServices(): Promise<
  PublishedConversionServiceDto[]
> {
  return api<PublishedConversionServiceDto[]>("/catalog/published-services", {
    skipAuth: true,
  });
}
